import linters from '../../external/data/src/checks/index';

export const companyChecks = [...linters.recordlint.checks, ...linters.companylint.checks].filter(
    (c) => c.id !== 'pass-schema'
);
export { ajv } from '../../external/data/src/common/ajv';
export type { CheckInstance } from '../../external/data/src/types/checks';
